<div class="modal-header">
    <h5 class="modal-title">Processing Approvals</h5>
    <!-- <span class="fa fa-close" aria-label="Close" (click)="processing==2 && activeModal.close()"></span> -->
</div>

<div class="modal-body" *ngIf="processing != 0">
    <div class="percentage" *ngIf="total !=1">Processing {{approved}} of {{total}} items</div>
    <div class="percentage" *ngIf="total ==1">Processing approval</div>

    <div *ngIf="processing == 1" class="progress mt-2">
        <div class="progress-bar progress-bar-striped progress-bar-animated"
            [ngStyle]="{width: (approved/total)*100 + '%'}"></div>
    </div>
    <p class="message mt-2">
        {{processing == 1 ? 'Applying approvals...' : (processing == 2 ? 'Done' : '') }}
    </p>
</div>

<!-- <div class="modal-footer">
    <button type="button" class="btn btn-default" [disabled]="processing!=2"
        (click)="activeModal.close()">Close</button>
</div> -->